export const FETCH_TEMPLATE_URL = `${process.env.REACT_APP_API_BASE_URL}/getTemplates`;
export const SAVE_TEMPLATE_URL = `${process.env.REACT_APP_API_BASE_URL}/templateSave`;

export const MESSAGES = {
  SUCCESS_SAVE: "Your template has been saved successfully!",
  ERROR_SAVE: "An error occurred while saving the template data.",
  ERROR_SAVE_FAIL: "Failed to save the template data. Please try again later."
};
